<ng-container [ngSwitch]="action$ | async">
  <mbs-install-system-update *ngSwitchCase="selectedActionEnum.WindowsUpdates"></mbs-install-system-update>
  <mbs-uninstall-software *ngSwitchCase="selectedActionEnum.Uninstall"></mbs-uninstall-software>
  <mbs-update-policy *ngSwitchCase="selectedActionEnum.UpdatePolicy"></mbs-update-policy>
  <mbs-install-software-common *ngSwitchCase="selectedActionEnum.InstallAndUpdate"></mbs-install-software-common>

  <mbs-execute-script *ngSwitchDefault></mbs-execute-script>
</ng-container>
